import { useTranslation } from "next-i18next";
import React from "react";

import { useFeatureFlags } from "@/hooks/useFeatureFlags";

import styles from "./top-banner.module.scss";

export const HelpTopBanner: React.FC = () => {
    const { t } = useTranslation();
    const { helpCentreBannerEnabled } = useFeatureFlags();

    if (!helpCentreBannerEnabled) return null;

    return (
        <div className={styles.banner}>
            <p className={styles.title}>{t("help.banner")}</p>
            <p className={styles.subtitle}>{t("help.bannerSubtitle")}</p>
        </div>
    );
};
